import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../../../stores';
import * as styles from "../../Megamenu.css";
import { IAIcon } from '../../../../icon/Icon';

export interface IHorizontalBarProps {
  navigatorStore?: NavigatorStore;
}

@inject('navigatorStore')
@observer
export class HorizontalBar extends React.Component<IHorizontalBarProps> {

  constructor(props: IHorizontalBarProps) {
    super(props);
  }

  public render(): JSX.Element {
    return (
      <div
        key={"hiddenHorizontalMenu"}
      >
        <div className={styles.hiddenHorizontalMenu} id="hiddenHorizontalMenu">
          {this.props.navigatorStore.topItems}
        </div>
        <div
          className={styles.horizontalMenu}
          id="IA_navigator_horizontal_menu"
          style={{
            width: !isNaN(this.props.navigatorStore.horizontalMenuWidth) ? this.props.navigatorStore.horizontalMenuWidth : 0,
            left: this.props.navigatorStore.horizontalMenuLeft,
            top: this.props.navigatorStore.navigatorTop,
            height: this.props.navigatorStore.navigatorHeight
          }}
        >
          {this.props.navigatorStore.horizontalTopItemsToDisplay}
          {this.props.navigatorStore.moreHorizontalTopItemsToDisplay != undefined &&
            <div
              className={styles.moreHorizontalMenu}
              id="moreHorizontalMenu"
              style={{
                left: -this.props.navigatorStore.horizontalMenuLeft,
                width: !isNaN(this.props.navigatorStore.width) ? this.props.navigatorStore.width : 0
              }}
            >
              {this.props.navigatorStore.moreHorizontalTopItemsToDisplay}
              <IAIcon
                title="Close"
                size={25}
                color={this.props.navigatorStore.navigator.design.menuBar.iconColor}
                style={{
                  float: "right",
                  marginLeft: 10,
                  cursor: "pointer",
                  backgroundColor: "#ffffff20",
                  padding: "8px 6px 4px 6px"
                }}
                tabIndex={1}
                onClick={() => {
                  this.props.navigatorStore.showMoreHorizontalTopItems = false;
                  this.props.navigatorStore.moreHorizontalTopItemsToDisplay = undefined;
                  if (this.props.navigatorStore.droppableTopItemSpotsAreShowing) {
                    this.props.navigatorStore.hideDroppableTopItemSpots();
                    this.props.navigatorStore.selectTopMenuItem(undefined);
                  }
                  this.props.navigatorStore.getTopItems();
                  this.props.navigatorStore.resize();
                }}
              />
            </div>
          }
          {this.props.navigatorStore.showMoreHorizontalTopItemsButton && !this.props.navigatorStore.isShowingAdditionalSmartmenuItems &&
            <IAIcon
              title="More"
              size={25}
              color={this.props.navigatorStore.navigator.design.menuBar.iconColor}
              style={{
                marginTop: 8,
                float: "left",
                marginLeft: 10,
                cursor: "pointer"
              }}
              tabIndex={1}
              onClick={() => {
                this.props.navigatorStore.showMoreHorizontalTopItems = true;
                this.props.navigatorStore.resize();
              }}
            />
          }
        </div>
      </div>
    );
  }
}